import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { User } from 'app/modules/domain/models/user';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.scss']
})
export class DeleteUserComponent implements OnInit {
  public user: User;

  constructor(public dialogRef: MdDialogRef<DeleteUserComponent>,
              @Inject(MD_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.user = this.data.user;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/shared/delete-user/delete-user.component.ts